import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import {
	PdfRequestsRepository,
	PlanItemsRepository,
	PlansRepository,
	PlanVersionsRepository,
} from '@efficiently/client-api-plans';

import { PdfRequestsGqlRepository } from './repositories/pdf-requests-gql.repository';
import { PlanItemsGqlRepository } from './repositories/plan-items-gql.repository';
import { PlanVersionsGqlRepository } from './repositories/plan-versions-gql.repository';
import { PlansGqlRepository } from './repositories/plans-gql.repository';

export function providePlansDataAccess(): EnvironmentProviders {
	return makeEnvironmentProviders([
		{ provide: PlansRepository, useClass: PlansGqlRepository },
		{ provide: PlanVersionsRepository, useClass: PlanVersionsGqlRepository },
		{ provide: PlanItemsRepository, useClass: PlanItemsGqlRepository },
		{ provide: PdfRequestsRepository, useClass: PdfRequestsGqlRepository },
	]);
}
